import React from "react";
import MatomoContext from "../context/MatomoContext";
export default function MatomoProvider(_ref) {
  let {
    instance,
    children
  } = _ref;
  const Context = MatomoContext;
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: instance
  }, children);
}